import { render, staticRenderFns } from "./CalendarShareItem.vue?vue&type=template&id=6cfbe2e5&scoped=true"
import script from "./CalendarShareItem.vue?vue&type=script&lang=js"
export * from "./CalendarShareItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfbe2e5",
  null
  
)

export default component.exports